import { MdOutlineCalendarMonth } from 'react-icons/md';
import { BsReverseListColumnsReverse } from 'react-icons/bs';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { TbReportSearch } from 'react-icons/tb';

const tiles = [
  {
    sNo: 1,
    link: '/common/spcPlanlist',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'SPC',
    span: 'PLAN',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/spcPlanChecklist',
    isLink: true,
    icon: <BsReverseListColumnsReverse size="5rem" color="#087f5b" />,
    p: 'SPC',
    span: 'STATUS',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/spc/partlist',
    isLink: true,
    icon: <TbReportSearch size="5rem" color="#343a40" />,
    p: 'SPC',
    span: 'REPORT',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="SPC" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
